var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-number',_vm._b({model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'vue-number',_vm.numberSetting,false))
}
var staticRenderFns = []

export { render, staticRenderFns }